var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #24b354;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 48.41,
    y1: 1426.81,
    x2: 63.93,
    y2: 1350.1,
    gradientTransform: "translate(0 1434) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.45,97.66c-2.93-2.31-6.35-3.93-10-4.73-9.55-2.27-16.28-10.8-16.29-20.61V22C10.16,10.3,19.64.82,31.34.82h50.32c11.7,0,21.18,9.48,21.18,21.18v50.32c-.01,9.82-6.77,18.35-16.33,20.61-3.65.8-7.07,2.42-10,4.73l-16.05,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.51,10.2h50.15c6.52,0,11.8,5.28,11.8,11.8v50.32c0,6.52-5.28,11.8-11.8,11.8H31.34c-6.52,0-11.8-5.28-11.8-11.8h0V22.17c0-6.63,5.37-12,12-12l-.03.03Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    className: "cls-2",
    d: "m84,28.97c-13.06,5.25-16.71,24.64-23.14,37.26-2.08,4.06-4.09,5.96-7.55,5.96-2.17-.05-4.19-1.14-5.43-2.93l-17.21-28.57c-8.95-14.86,20.29-18.14,37.55-14.54-5.11,2.22-8.93,6.14-14.11,20.88-.31.89-1.13,1.5-2.07,1.54-.93.08-1.83-.41-2.26-1.24l-4.99-9.15c-.5-1.02-1.1-1.98-1.81-2.86-.63-.58-1.51-.8-2.34-.57-.54.08-1.04.31-1.46.65-.41.33-.73.75-.93,1.23-.19.43-.26.9-.19,1.37.06.34.17.67.31.98.16.37.35.74.56,1.09l.61,1.06,8.48,14.11c.85,1.35,1.43,2.26,1.76,2.71.38.49.86.89,1.41,1.17.7.34,1.5.44,2.27.28.62-.08,1.22-.31,1.73-.68.45-.35.82-.79,1.06-1.31,9.41-19.33,8.6-30.27,27.76-28.43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerde);
export default __webpack_public_path__ + "static/media/verde.03117270848bfb96f8971f7247e3a315.svg";
export { ForwardRef as ReactComponent };